// styles/theme.js

const theme = {
	colors: {
		primary: '#3498db', // Azul claro
		secondary: '#2ecc71', // Verde
		accent: '#e74c3c', // Rojo
		background: '#ecf0f1', // Gris claro
		text: '#2c3e50', // Gris oscuro
		white: '#ffffff',
		black: '#000000',
		// Puedes agregar más colores según tus necesidades
		neon: {
			celeste: '#3efffc',
			magenta: '#ff3ef7',
			rojo: '#ff3e45',
			verde: '#3eff9f',
			acid: '#aaff3e',
			amarillo: '#fffb3e',
			azul: '#3e6fff',
			naranja: '#ff873e',
			violeta: '#6f3eff'
		}
	},
	fonts: {
		main: 'Arial, sans-serif',
		code: 'Courier New, monospace'
	},
	fontSizes: {
		small: '0.8rem',
		medium: '1rem',
		large: '1.5rem'
	},
	spacing: {
		small: '8px',
		medium: '16px',
		large: '24px'
	}
	// Puedes agregar más propiedades, como tamaños de borde, sombras, etc.
}

export default theme
